// [D-593] OWNER 16.10: «зроби кнопку «🧪 Тестовий» на сторінці юзер». Тестовий акаунт = тег «🧪 тест» у нотатках юзера (user_notes.tags):
// автозакриття доступу за строком (subscription_expire.py, D-592) його не чіпає, у списку «Юзери» біля імені - 🧪.
// Той самий GET/PUT /api/users/{id}/notes, що й нотатки: текст нотатки не міняємо, лише тег.
import React, { useEffect, useState } from 'react';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import api from '../api';

const TAG = '🧪 тест';

export default function UserTestFlag({ userId }) {
  const [st, setSt] = useState(null);   // { note, tags }
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  useEffect(() => {
    let dead = false;
    setSt(null); setErr('');
    api.get(`/users/${userId}/notes`)
      .then(r => { if (!dead) setSt({ note: (r.data && r.data.note) || '', tags: (r.data && r.data.tags) || [] }); })
      .catch(() => { if (!dead) setErr('Не вдалося прочитати позначку'); });
    return () => { dead = true; };
  }, [userId]);
  if (!st) return err ? <Typography sx={{ color: '#ff8a80', fontSize: 12, mb: 2 }}>{err}</Typography> : null;
  const on = st.tags.includes(TAG);
  const toggle = () => {
    const tags = on ? st.tags.filter(t => t !== TAG) : [...st.tags, TAG];
    setBusy(true); setErr('');
    api.put(`/users/${userId}/notes`, { note: st.note, tags })
      .then(() => setSt({ ...st, tags }))
      .catch(() => setErr('Не вдалося зберегти'))
      .finally(() => setBusy(false));
  };
  return (
    <Box data-test-flag={on ? '1' : '0'} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', mt: -2, mb: 3 }}>
      <Tooltip title={on ? 'Зняти позначку: доступ знову закриватиметься, коли мине строк' : 'Позначити тестовим: доступ не закриватиметься за строком'}>
        <span>
          <Button size="small" disabled={busy} onClick={toggle} data-test-flag-btn="1"
                  sx={{ textTransform: 'none', fontWeight: 800, borderRadius: 2, px: 1.5,
                        color: on ? '#0b1020' : '#b39ddb', bgcolor: on ? '#b39ddb' : 'transparent', border: '1px solid #b39ddb',
                        '&:hover': { bgcolor: on ? '#c5b3e6' : 'rgba(179,157,219,.12)' } }}>
            {on ? '🧪 Тестовий ✓' : '🧪 Тестовий'}
          </Button>
        </span>
      </Tooltip>
      <Typography sx={{ color: 'rgba(255,255,255,.6)', fontSize: 12.5 }}>
        {on ? 'Тестовий акаунт: доступ не закривається за строком.' : 'Звичайний: доступ закривається сам, коли мине строк.'}
      </Typography>
      {err && <Typography sx={{ color: '#ff8a80', fontSize: 12 }}>{err}</Typography>}
    </Box>
  );
}
